import { useLogoValue } from '@web/components/utils/branding/useBrandingsStore'
import { ImageIcon } from '../Icons'
import { Box, Flex } from '../Layout'
import { Image } from '@web/components/atoms/Image'

export enum LogoDisplay {
  None = 'None',
  Circle = 'Circle',
  Rectangle = 'Rectangle',
  Primary = 'Primary',
  Reversed = 'Reversed',
  Custom = 'Custom',
}

export type LogoStyles = {
  logo?: LogoDisplay
  logoUrl?: string
  logoHref?: string
  logoTarget?: string
  logoWidth?: string
  logoHeight?: string
}

type LogoProps = {
  styles: LogoStyles
  showPreview?: boolean
}

const getLogoStyles = (type: LogoDisplay, styles?: LogoStyles) => {
  switch (type) {
    case LogoDisplay.Circle:
    case LogoDisplay.Rectangle:
    case LogoDisplay.Primary:
    case LogoDisplay.Reversed:
      return {
        maxW: '125px',
        maxH: '75px',
      }
    case LogoDisplay.None:
      return {
        display: 'none',
      }
    case LogoDisplay.Custom:
      return {
        maxW: styles?.logoWidth,
        width: 'auto',
        height: 'auto',
      }
    default:
      return {}
  }
}

const Logo = ({ showPreview, styles = {} }: LogoProps) => {
  const [type, value] = useLogoValue(styles.logo, styles.logoUrl)
  const { logoTarget: target = '_blank', logoHref: href } = styles

  return (
    <Flex justifyContent="center" transition="all 0.2s ease-in-out" alignItems="center">
      {value && (
        <Box {...(href ? { as: 'a', href, target } : {})} w="100%">
          <Image src={value} {...getLogoStyles(type, styles)} />
        </Box>
      )}
      {!value && showPreview && type !== LogoDisplay.None && (
        <Flex backgroundColor="#01567B" w="64px" h="64px" alignItems="center" justifyContent="center">
          <ImageIcon color="#D8E7EF" boxSize={8} />
        </Flex>
      )}
    </Flex>
  )
}

export default Logo
